import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AlertsService, AppAlert } from '../../../services/alerts.service';

/**
 * Rendered inside a MatSnackBar when a notification arrives over the socket, so
 * a user who isn't looking at the bell still notices.
 *
 * Reuses AppAlert, which means the toast and the dropdown always show the same
 * icon and copy for a given notification.
 */
@Component({
  selector: 'app-notification-toast',
  imports: [MatIconModule],
  templateUrl: './notification-toast.html',
  styleUrl: './notification-toast.css',
})
export class NotificationToast {
  alert = inject<AppAlert>(MAT_SNACK_BAR_DATA);

  private router = inject(Router);
  private snackBarRef = inject(MatSnackBarRef);
  private alertsService = inject(AlertsService);

  /**
   * Opening marks the notification read, the same as clicking it in the bell.
   */
  open(): void {
    this.alertsService.markRead(this.alert);
    this.router.navigateByUrl(this.alert.route);
    this.snackBarRef.dismiss();
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
